<template>
  <div class="vital_sign">
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <div class="row">
        <div
          class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 d-flex align-items-center"
        >
          <v-btn class="btn-return" v-on:click="handleToBack">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
          </v-btn>
        </div>
        <div
          class="col-xl-11 col-lg-10 col-md-10 col-sm-9 col-12 d-flex justify-content-start"
        >
          <h1 class="title-pages pt-1">SINAIS VITAIS</h1>
        </div>
      </div>
      <VitalSigns
        :id="id"
        :rest_home_id="rest_home_id"
        :resident_id="vital_sign.resident_id"
        :resident_name="vital_sign.resident_name"
        :user="user"
        :createdAt="createdAt"
      />

      <LinkVerLocalizacaoRegistro :item="vital_sign" />
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import LinkVerLocalizacaoRegistro from "../templates/Components/LinkVerLocalizacaoRegistro";

import VitalSigns from "../templates/Care/NursingCaregiver/View/VitalSigns";

import api from "../services/api";

import routes from "../routes";

import { userData, getStatic } from "../lib/functions";

export default {
  name: "VitalSign",
  components: {
    NavBar,
    AuthBySessionExpired,
    VitalSigns,
    LinkVerLocalizacaoRegistro,
  },
  data() {
    return {
      active: "vital_signs",
      rest_home_id: "",
      id: "",
      vital_sign: {},
      user: {},
      loading: true,
      createdAt: true,
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    handleType(type) {
      var show = {
        CUIDADOR_ENFERMAGEM: "Cuidador/Enfermagem",
        ENFERMEIRA: "Enfermeira",
        MEDICO: "Médico",
        EQUIPE_MULTIDISCIPLINAR: "Equipe Multidisciplinar",
        default: "Tipo não encontrado!",
      };

      return show[type] || show.default;
    },
    async retrieve() {
      const { user } = userData();

      this.rest_home_id = user.rest_home_id;

      this.user = user;

      const { id } = routes.history.current.params;

      this.id = id;

      let accessed_offline = JSON.parse(
        sessionStorage.getItem("accessed_offline") || !this.$store.state.online
      );

      this.accessed_offline = accessed_offline;

      if (accessed_offline) {
        let residents = (
          await getStatic("/offline/residents/vital-signs", true)
        ).residents;

        let vitalSigns = [];
        for (let resident of residents) {
          vitalSigns.push(...resident.vitalSigns);
        }

        let vital_sign = vitalSigns.filter((item) => item.id == id);

        if (vital_sign[0]) {
          this.vital_sign = vital_sign[0];
          this.createdAt = false;
        }
        this.loading = false;
      } else {
        await this.get();
      }
    },
    async get() {
      try {
        this.loading = true;

        let { id } = this;

        var params = { id };

        const response = await api.get("/rest-home/vital-sign/get", {
          params,
        });

        const { error, care_vital_sign, createdAt } = response.data;

        if (error) {
          return routes.go(-1);
        }

        this.vital_sign = care_vital_sign;
        this.createdAt = createdAt;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleToBack: () => routes.go(-1),
  },
};
</script>

<style>
.vital_sign .ssvv-top {
  width: 50%;
  text-align: center;
  text-transform: uppercase;
  color: #000;
  font-weight: 600;
}

.vital_sign .nav-tabs .nav-link.active {
  background-color: #1f5a76;
  color: #fff;
  border-color: #1f5a76;
}
</style>
